import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import * as action from 'app/features/orders/redux/order/refundSlice'
import React from 'react'
import FulfilledItems from './FulfilledItems'
import RefundOrderLineItems from './RefundOrderLineItems'
import RestockLocation from './RestockLocation'

interface Props {}

export const RefundLineItems: React.FC<Props> = () => {
  const dispatch = useDispatch()
  const orderItems = useSelector<RootState, any[]>(action.selectRefundItems)

  const handleValidateDiscount = () => {
    dispatch(action.validateOrderRefund())
  }

  const handleCheckRefundAll = () => {
    dispatch(action.setRefundAll(orderItems))
    dispatch(action.setOrderItems([]))
    handleValidateDiscount()
  }

  return (
    <>
      <FulfilledItems onValidate={handleValidateDiscount}>
        <button
          id='chkRefundAll'
          onClick={handleCheckRefundAll}
          className='btn btn-sm explore-btn-outline w-100 w-125px mb-2'
        >
          Refund All
        </button>
      </FulfilledItems>
      <RefundOrderLineItems onValidate={handleValidateDiscount}>
        <RestockLocation />
      </RefundOrderLineItems>
    </>
  )
}

export default RefundLineItems
